import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { clivageKeys } from '../queries/keys';
import { clivagePaths } from '../queries/paths';

// TSS vite/03 — clivage mutations (api-reference/admin-clivages.md).
// Bulk create is atomic (conservation summed per aspiration over the whole batch).

export function useCreateClivagesBulk() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (items) => api.post(clivagePaths.bulk(), { items }).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: clivageKeys.all });
            qc.invalidateQueries({ queryKey: ['opu'] }); // refresh OPU counts/timeline
        },
    });
}

// Loads the FULL clivages of a session: list per aspiration, then GET each (the
// list summary lacks stages/type). Used by the clivage edit workspace.
export function useSessionClivages(sessionId, aspirationIds = []) {
    return useQuery({
        queryKey: ['clivages', 'session', sessionId, [...aspirationIds].sort().join(',')],
        enabled: !!sessionId && aspirationIds.length > 0,
        queryFn: async ({ signal }) => {
            const lists = await Promise.all(aspirationIds.map(aid =>
                api.get(clivagePaths.list(), { params: { aspiration: aid, status: 2, limit: 500 }, signal }).then(r => r.data.items || [])));
            const ids = lists.flat().map(c => c.id);
            const fulls = await Promise.all(ids.map(cid =>
                api.get(clivagePaths.detail(cid), { signal }).then(r => r.data)));
            return fulls;
        },
    });
}
